import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import PropTypes from 'prop-types';

const FormObserver = ({ onChange }) => {
  const { dirty } = useFormikContext();

  useEffect(() => {
    onChange(dirty);
  }, [dirty, onChange]);

  return null;
};

FormObserver.propTypes = {
  onChange: PropTypes.func,
};

export default FormObserver;
